import { creationExamples } from "./creation-examples";
import { combinationExamples } from "./combination-examples";
import { conditionalExamples } from "./conditional-examples";
import { filteringExamples } from "./filtering-examples";
import { mathExamples } from "./math-examples";
import { transformationExamples } from "./transformation-examples";
import { utilityExamples } from "./utility-examples";
import { flatternExamples } from "./flattern-examples";
import { multicastingExamples } from "./multicasting-examples";

// https://rxjs.dev/api/operators/merge
export const categories = {
  "Creation Observables": creationExamples,
  "Combination Operators": combinationExamples,
  "Flattern Operators": flatternExamples,
  "Multicasting Operators": multicastingExamples,
  "Transformation Operators": transformationExamples,
  "Filtering Operators": filteringExamples,
  "Conditional Operators": conditionalExamples,
  "Utility Operators": utilityExamples,
  "Mathematical Operators": mathExamples
};
